import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import objectParser from 'js-object-parser';
import Cookies from 'js-cookie';

const Context = React.createContext();

const TrafficSourceListener = ({ children }) => {
	const [cookies, setCookie, _] = useCookies(['CookieConsent', 'isOrganicReferrer']);
	const [marketingCookiesEnabled, setMarketingCookiesEnabled] = useState(false);

	const [consentCookie, setConsentCookie] = useState(null);

	const [isTestingEnabled, setIsTestingEnabled] = useState(false);

	let isOrganicReferrer = false;

	useEffect(() => {
		let hasUserVisitedBefore = false;

		if (typeof window !== 'undefined' && window && window.document) {
			hasUserVisitedBefore = localStorage.getItem('hasUserVisitedBefore');

			isOrganicReferrer =
				!hasUserVisitedBefore &&
				(window.document.referrer.includes('https://www.google.') ||
					window.document.referrer.includes('https://www.bing.'));

			const urlParams = new URLSearchParams(window.location.search);

			if (window.location.hostname !== 'netsurf.bg') {
				if (urlParams.has('utm_organic_testing')) {
					setIsTestingEnabled(true);
					sessionStorage.setItem('utm_organic_testing', true);
				} else if (sessionStorage.getItem('utm_organic_testing')) {
					setIsTestingEnabled(true);
				}
			}
		}

		if (isOrganicReferrer && !cookies.isOrganicReferrer && !hasUserVisitedBefore) {
			const now = new Date();
			const expires = new Date();
			expires.setDate(now.getDate() + 365);
			// expire in a year
			setCookie('isOrganicReferrer', true, { expires });
		}

		setTimeout(() => {
			localStorage.setItem('hasUserVisitedBefore', true);
		}, 2000);
	}, [cookies]);

	useEffect(() => {
		let intervalId = null;

		if (!cookies.CookieConsent) {
			intervalId = setInterval(() => {
				const cookieConsent = Cookies.get('CookieConsent');
				if (cookieConsent) {
					setConsentCookie(cookieConsent);
					clearInterval(intervalId);
				}
			}, 300);
		} else {
			setConsentCookie(cookies.CookieConsent);
		}

		return () => {
			clearInterval(intervalId);
		};
	}, [cookies]);

	useEffect(() => {
		if (consentCookie) {
			const cookieBotValue = consentCookie;

			if (cookieBotValue) {
				try {
					const decodedValue = decodeURIComponent(cookieBotValue);
					const quoted = decodedValue.replaceAll("'", '"');

					const consentObject = objectParser.parse(quoted);

					const { marketing: marketingEnabled } = consentObject;

					setMarketingCookiesEnabled(marketingEnabled);
				} catch (e) {
					console.error(`Problem while parsing CookieBot cookie`, e);
				}
			}
		}
	}, [consentCookie]);

	const isOrganic = Boolean(isOrganicReferrer || cookies.isOrganicReferrer);

	const contextValue = {
		marketingCookiesEnabled: isTestingEnabled || marketingCookiesEnabled,
		isOrganic: isTestingEnabled || isOrganic,
		supportPhone:
			isTestingEnabled || (marketingCookiesEnabled && isOrganic)
				? '+359 882 991 613'
				: '+359 885 25 0000',
		signupPhone:
			isTestingEnabled || (marketingCookiesEnabled && isOrganic)
				? '+359 882 991 626'
				: '+359 882 991 611'
	};

	return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

export const TrafficSourceContext = Context;

export default TrafficSourceListener;

